import gql from 'graphql-tag';

export const INVITATION_QUERY = gql`
  query clientAccountInvitation($token: UUID!) {
    invitation: clientAccountInvitation(token: $token) {
      id
      partner
      type
      payedBy
      invitedBy
      invitedAt
      expiresAt
      email
      fullName
      availableRoles {
        id
        name
        displayName
        description
      }
      ownerInvoiceCountry
    }

    countries: availableCountries

    locales: activeLocales

    timeZones: availableTimeZones

    availableTaxIds {
      id
      type
      country
      description
      variants {
        regularExpression
        example
      }
    }
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation acceptClientInvitation($input: AcceptClientInvitationInput!) {
    acceptClientInvitation(input: $input) {
      createdAccountId
      userId
      tokens {
        token
        refreshToken
      }
    }
  }
`;

export const ACCEPT_ESSENTIAL_ACCOUNT_INVITATION = gql`
  mutation acceptEssentialAccountInvitationMutation($input: AcceptEssentialAccountInvitationInput!) {
    acceptEssentialAccountInvitation(input: $input) {
      createdAccountId
      userId
      tokens {
        token
        refreshToken
      }
    }
  }
`;
